import { Path } from '@trwl/shared/lib/router';
import { useUnit } from 'effector-react';
import { usePathname, useSearchParams } from 'next/navigation';
import { useEffect } from 'react';

import { FILTERS } from './filter';

export function useSyncFilterWithQuery() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const pick = useUnit(FILTERS.queryPicked);

  const filter = searchParams.get('filter') || '';

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (pathname.startsWith(Path.CATALOG)) pick({ queryString: filter });
    }, 200);
    return () => clearTimeout(timeout);
  }, [pick, filter, pathname]);
}
